import React, { useState, useEffect } from "react";
import "./ItemCreate.css";
import AdminHeader from "../../../Component/AdminHeader/AdminHeader";
import InputError from "../../../Component/InputError/InputError";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";

import imp from "../../../Assets/imp.png";
import uploadImg from "../../../Assets/Upload B.png";
import alertImg from "../../../Assets/Group 36938.png";

export default function AddItem() {
  const API = "https://fliplyn-b-c.fly.dev";

  const location = useLocation();
  const navigate = useNavigate();

  // ✅ GET FROM NAVIGATION
  const stall_id = location.state?.stall_id;
  const category_id = location.state?.category_id;
  const admin_id = location.state?.admin_id;

  const [itemName, setItemName] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);      // preview
  const [imageFile, setImageFile] = useState(null); // actual file
  const [price, setPrice] = useState("");
  const [gst, setGst] = useState("");
  const [taxIncluded, setTaxIncluded] = useState(true);
  const [vegType, setVegType] = useState("veg");
  const [availability, setAvailability] = useState("available");
  const [errors, setErrors] = useState({});

  // 🟢 Load saved data if refreshed
  useEffect(() => {
    const saved = JSON.parse(localStorage.getItem("addItemForm"));
    if (saved) {
      setItemName(saved.itemName || "");
      setDescription(saved.description || "");
      setImage(saved.image || null);
      setPrice(saved.price || "");
      setGst(saved.gst || "");
      setTaxIncluded(saved.taxIncluded ?? true);
      setVegType(saved.vegType || "veg");
      setAvailability(saved.availability || "available");
    }
  }, []);

  // 🟢 Auto-save
  useEffect(() => {
    localStorage.setItem(
      "addItemForm",
      JSON.stringify({
        itemName,
        description,
        image,
        price,
        gst,
        taxIncluded,
        vegType,
        availability,
      })
    );
  }, [itemName, description, image, price, gst, taxIncluded, vegType, availability]);

  // ✅ IMAGE HANDLER (IMPORTANT FIX)
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setImageFile(file); // actual file
    const imgURL = URL.createObjectURL(file);
    setImage(imgURL); // preview
  };

  const finalPrice = () => {
    if (!price) return "0.00";
    if (taxIncluded) return Number(price).toFixed(2);
    if (!gst) return Number(price).toFixed(2);
    const added = Number(price) + (Number(price) * Number(gst)) / 100;
    return added.toFixed(2);
  };

  const validate = () => {
    let err = {};
    if (!itemName) err.itemName = "Item name is required";
    if (!description) err.description = "Description is required";
    if (!imageFile) err.image = "Image is required";
    if (!price) err.price = "Price is required";
    if (!taxIncluded && !gst) err.gst = "GST percentage is required";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  // 🧹 Clear
  const clearAll = () => {
    localStorage.removeItem("addItemForm");
    setItemName("");
    setDescription("");
    setImage(null);
    setImageFile(null);
    setPrice("");
    setGst("");
    setTaxIncluded(true);
    setVegType("veg");
    setAvailability("available");
  };

  // ✅ CREATE ITEM API
  const handleCreateItem = async () => {
    if (!validate()) return;

    try {
      const formData = new FormData();

      formData.append("name", itemName);
      formData.append("description", description);
      formData.append("price", Number(price));
      formData.append("Gst_precentage", taxIncluded ? 0 : Number(gst));
      formData.append("tax_included", taxIncluded);
      formData.append("is_available", availability === "available");
      formData.append("is_veg", vegType === "veg");

      formData.append("stall_id", stall_id);
      formData.append("category_id", category_id);

      if (admin_id) {
        formData.append("admin_id", admin_id);
      }

      if (imageFile) {
        formData.append("file", imageFile);
      }

      const res = await axios.post(`${API}/items/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("✅ ITEM CREATED:", res.data);

      alert("Item created successfully");
      clearAll();

      // ✅ Navigate back to items list
      navigate(-1);

    } catch (error) {
      console.error("❌ CREATE ITEM ERROR:", error);
      alert("Failed to create item");
    }
  };

  return (
    <div className="items">
      <AdminHeader />
      <div className="addItem-container">
        <h2 className="addItem-title">Add New Item</h2>

        <div className="addItem-content">
          {/* LEFT SIDE */}
          <div className="addItem-left">
            <label className="input-label">
              Item Name <img src={imp} alt="required" className="imp-icon" />
            </label>
            <input
              type="text"
              className="input-box"
              placeholder="e.g., Classic Chicken Biryani"
              value={itemName}
              onChange={(e) => setItemName(e.target.value)}
            />
            <InputError message={errors.itemName} />

            <label className="input-label">
              Description <img src={imp} alt="required" className="imp-icon" />
            </label>
            <textarea
              className="textarea-box"
              maxLength={100}
              placeholder="Short description shown in menu (optional)"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            ></textarea>
            <InputError message={errors.description} />

            <label className="input-label">
              Image <img src={imp} alt="required" className="imp-icon" />
            </label>
            <div
              className="image-upload-box"
              onClick={() => document.getElementById("fileUpload").click()}
            >
              <input
                id="fileUpload"
                type="file"
                accept="image/*"
                onChange={handleImageUpload}
                className="file-input"
              />
              <img src={uploadImg} alt="upload icon" className="upload-img" />
            </div>
            <InputError message={errors.image} />

            <label className="input-label">
              Price <img src={imp} alt="required" className="imp-icon" />
            </label>
            <input
              type="number"
              className="input-box"
              placeholder="₹ 199"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
            />
            <InputError message={errors.price} />

            <p className="preview-price">Preview: ₹{finalPrice()}</p>

            <div className="switch-row">
              <span className="switch-label">Tax included.</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={taxIncluded}
                  onChange={() => setTaxIncluded(!taxIncluded)}
                />
                <span className="slider"></span>
              </label>
            </div>

            <label className="input-label">
              GST Percentage <img src={imp} alt="required" className="imp-icon" />
            </label>
            <input
              type="number"
              className="input-box"
              placeholder="5%"
              value={gst}
              onChange={(e) => setGst(e.target.value)}
              disabled={taxIncluded}
            />
            <InputError message={errors.gst} />

            <label className="input-label">
              Availability <img src={imp} alt="required" className="imp-icon" />
            </label>

            <div className="availability-buttons">
              <button
                className={`availability-btn ${availability === "available" ? "active-available" : "inactive"}`}
                onClick={() => setAvailability("available")}
              >
                Available
              </button>

              <button
                className={`availability-btn ${availability === "paused" ? "active-paused" : "inactive"}`}
                onClick={() => setAvailability("paused")}
              >
                Paused
              </button>
            </div>
          </div>

          {/* RIGHT SIDE (UNCHANGED UI) */}
          <div className="addItem-right">{/* same as yours */}</div>
        </div>

        <div className="footer-buttons">
          <div className="unsaved-changes">
            <p className="text">
              <img src={alertImg} alt="alert" className="alert-img" />
              Unsaved changes
            </p>
          </div>

          <div className="right-buttons">
            <button className="cancel-button" onClick={clearAll}>
              Cancel
            </button>

            <button className="create-btn" onClick={handleCreateItem}>
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}